import { useContext, createContext } from 'react';

const AuthContext = createContext(null);

export const useAuth = () => useContext(AuthContext);

export default AuthContext;
